import { Component, ElementRef, HostListener, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-fcu-num-selector',
    templateUrl: './fcu-num-selector.component.html',
    styleUrl: './fcu-num-selector.component.css',
    standalone: false,
})
export class FcuNumSelectorComponent {
    @ViewChild('listInput') listInput: ElementRef;
    @ViewChild('listContainer') listContainer: ElementRef;

    selectedFcu: number;
    fcuOptions: number[] = [];

    showList: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            fcuOptions: number[];
            isImport: boolean;
        },
        private dialogRef: MatDialogRef<FcuNumSelectorComponent>,
        private translate: TranslateService
    ) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (
            this.showList &&
            !this.listContainer?.nativeElement.contains(event.target) &&
            !this.listInput?.nativeElement.contains(event.target)
        ) {
            this.showList = !this.showList;
        }
    }

    async ngOnInit() {
        this.fcuOptions = this.data.fcuOptions;
        this.selectedFcu = this.fcuOptions[0];
    }

    handleFcuSelected(fcuNum: number) {
        this.selectedFcu = fcuNum;
        this.showList = false;
    }

    close() {
        this.dialogRef.close();
    }

    selectVersion() {
        this.dialogRef.close(this.selectedFcu);
    }

    openList() {
        this.showList = !this.showList;
    }

    get displayedFcu() {
        if (!this.selectedFcu) return;
        return this.translate.instant('dlg.FCU', {
            num: this.selectedFcu,
        });
    }

    get isImport() {
        return this.data.isImport;
    }
}
